import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ConsultantCard from "../components/ConsultantCard";
import {
    getNearbyConsultants,
    setConsultantData,
} from "../actions/consultantsActions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import GoogleAddressAutoComplete from "../components/GoogleAddressAutoComplete";


export default function NearbyConsultants(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const settings = useSelector(state => state.settings);

    const StatusEnum = {
        FIRSTLOAD: "firstLoad",
        LOADING: "loading",
        SUCCESS: "success",
        ERROR: "error",
    };

    const [selectedAddressLocation, setSelectedAddressLocation] = useState({});
    const [consultants, setConsultants] = useState([]);
    const [searchStatus, setSearchStatus] = useState(StatusEnum.FIRSTLOAD);

    const contactConsultantHandler = (
        consultantId,
        consultantName,
        consultantEmail
    ) => {

        let consultant = {
            id: consultantId,
            name: consultantName,
            email: consultantEmail,
        };
        dispatch(setConsultantData(consultant));
        history.push(`${settings.baseUrl}contactrep${history.location.search}`);

    };

    const searchHandler = (addressObject) => {
        setSelectedAddressLocation(addressObject);
        setSearchStatus(StatusEnum.LOADING);
        if (addressObject) {
            dispatch(getNearbyConsultants(addressObject, 1, 3)).then((response) => {
                if (
                    response &&
                    response.value &&
                    response.value.status === 200 &&
                    response.value.data.result.length > 0
                ) {
                    // pagination not handled yet
                    setConsultants(response.value.data.result);
                    setSearchStatus(StatusEnum.SUCCESS);
                } else {
                    setConsultants([]);
                    setSearchStatus(StatusEnum.ERROR);
                }
            });
        } else {
            setConsultants([]);
            setSearchStatus(StatusEnum.ERROR);
        }
    };


    return (
        <Fragment>

            <div>
                {settings && settings.useAddressAutoCompleteInVipShop && settings.googleKey && <GoogleAddressAutoComplete settings={settings} onChange={searchHandler} />}
                {(!settings || !settings.useAddressAutoCompleteInVipShop || !settings.googleKey) &&
                    <div className="col-lg-5 align-self-center m-4 text-center align-middle alert alert-danger">
                    {t(
                        "Search is disabled"
                    )}
                </div>
                }

            </div>
            {consultants.length > 0 === false &&
                searchStatus === StatusEnum.ERROR && (
                    <div className="row justify-content-md-center">
                        <div className="col-lg-5  align-self-center m-4 text-center align-middle alert alert-info">
                            {t(
                                "No Consultants Found In This Area. Please Try Another Address."
                            )}
                        </div>
                    </div>
                )}
            {consultants.length > 0 && searchStatus === StatusEnum.SUCCESS && (
                <div className="d-flex flex-column justify-content-center mb-2 g-3">
                    {consultants.map((consultant) => (
                        <ConsultantCard
                            key={consultant.id}
                            isHorizontal={false}
                            consultant={consultant}
                            settings={settings}
                            listName="eprs"
                            listId={123}
                            className="w-450 mb-1 p-2"
                            contactConsultantHandler={contactConsultantHandler}
                        />
                    ))}
                </div>
            )}
        </Fragment>
    );
}
